/* unplugin-vue-components disabled */import script from "./Aptoide.vue?vue&type=script&setup=true&lang=ts"
export * from "./Aptoide.vue?vue&type=script&setup=true&lang=ts"

import "./Aptoide.vue?vue&type=style&index=0&id=36feffaf&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36feffaf"]])

export default __exports__